import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20coral%20and%20cream%20tones%2C%20subtle%20geometric%20patterns%2C%20elegant%20corporate%20aesthetic%2C%20warm%20lighting%2C%20minimalist%20design%2C%20professional%20atmosphere&width=1800&height=800&seq=clsq-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-600/90 to-primary-800/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好开始了吗？
        </h2>
        <p className="text-sm md:text-base text-background-200/90 max-w-xl mx-auto mb-8 leading-relaxed">
          立即联系我们，获取专属产品方案与报价。clsq专业团队将在24小时内与您取得联系，
          为您量身定制最适合的解决方案。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about#contact"
            className="px-8 py-3 bg-background-50 text-primary-700 rounded-md text-sm md:text-base font-semibold hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即咨询
          </Link>
          <Link
            to="/categories"
            className="px-8 py-3 bg-transparent text-background-50 border border-background-50/40 rounded-md text-sm md:text-base font-medium hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            浏览产品
          </Link>
        </div>
      </div>
    </section>
  );
}